import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
// components
import { Button, Icons, Card } from '..';
export const MultiOptionButton = ({ options, onSelect, className, onClick, selectedOption }) => {
    const wrapperRef = useRef(null);
    const [openDropDown, updateOpenDropDown] = useState(false);
    const [selectedButtonOption, updateSelectedButtonOption] = useState(null);
    const toggleDropdown = (value) => {
        updateOpenDropDown(value);
    };
    const updateSelectedOption = (item) => {
        updateSelectedButtonOption(item);
        if (onSelect) {
            onSelect(item);
        }
        toggleDropdown(false);
    };
    useEffect(() => {
        window.addEventListener('mousedown', handleClickOutside);
        window.addEventListener('keydown', handleClickOutside);
        return () => {
            window.removeEventListener('mousedown', handleClickOutside);
            window.removeEventListener('keydown', handleClickOutside);
        };
    });
    useEffect(() => {
        if (selectedOption) {
            updateSelectedButtonOption(selectedOption);
        }
    }, [selectedOption]);
    const handleClickOutside = event => {
        const { current: wrap } = wrapperRef;
        if ((wrap && !wrap.contains(event.target)) || event.keyCode === 9) {
            toggleDropdown(false);
        }
    };
    const onButtonClick = () => {
        toggleDropdown(false);
        if (onClick) {
            onClick();
        }
    };
    return (React.createElement("div", { className: classNames(className, 'multioptions-button-container'), ref: wrapperRef },
        React.createElement("div", { className: "multioptions-button_btn-container" },
            React.createElement(Button, { className: "multioptions-button_btn", style: "primary", type: "button", onClick: onButtonClick }, selectedButtonOption && selectedButtonOption.label),
            React.createElement("div", { className: "multioptions-button_down-icon", onClick: () => toggleDropdown(true) },
                React.createElement(Icons, { size: 14, iconName: "ic-ui-chevron-down-sm", className: "ic-ui-chevron-down" }))),
        openDropDown && (React.createElement(Card, { className: "multioptions-button_option-items" },
            React.createElement("ul", null, options &&
                options.map((option, index) => (React.createElement("li", { key: `${option.key}${index}`, className: "multioptions-button_option_item", onClick: () => updateSelectedOption(option) }, option.label))))))));
};
//# sourceMappingURL=MultiOptionButton.js.map